import { render, staticRenderFns } from "./HomePageCompaniesWhoTrust.vue?vue&type=template&id=3d5b135c&scoped=true&"
import script from "./HomePageCompaniesWhoTrust.vue?vue&type=script&lang=js&"
export * from "./HomePageCompaniesWhoTrust.vue?vue&type=script&lang=js&"
import style0 from "./HomePageCompaniesWhoTrust.vue?vue&type=style&index=0&id=3d5b135c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5b135c",
  null
  
)

export default component.exports